<header class="flex justify-between items-center px-6 py-3 border-b">
  <div class="flex items-center gap-3">
    <div
      class="flex items-center gap-2 cursor-pointer"
      (dblclick)="isVersionEnabled.set(!isVersionEnabled())"
      (click)="router.navigate(['/'])"
      (keydown.enter)="router.navigate(['/'])"
      (keydown.space)="$event.preventDefault(); router.navigate(['/'])"
      role="button"
      tabindex="0"
    >
      <span
        class="app-logo"
        aria-label="Logo"
        i18n-aria-label
        role="img"
      ></span>
      @if (isVersionEnabled()) {
        <span
          class="text-sm text-muted"
          [pTooltip]="apiVersionTooltip()"
          tooltipPosition="bottom"
        >
          Release v.{{ appReleaseVersion }}
        </span>
      }
    </div>
    <p-select
      class="min-w-36 max-w-48"
      [options]="companies()"
      [filter]="false"
      [loading]="companiesLoading()"
      [ngModel]="company()"
      (ngModelChange)="onCompanyChange($event)"
      placeholder="Caricamento..."
      i18n-placeholder
      optionLabel="name"
      optionValue="id"
      data-testid="companies-select"
    >
      <ng-template
        #selectedItem
        let-company
      >
        <div class="min-w-0">
          <span class="truncate">{{ company?.name }}</span>
        </div>
      </ng-template>

      <ng-template
        #item
        let-company
      >
        <div class="flex w-full min-w-0 items-center justify-between gap-4">
          <span class="truncate">{{ company?.name }}</span>
          <span
            class="shrink-0 rounded bg-background-neutral px-2 py-0.5 text-xs font-medium uppercase"
          >
            {{ contentCultures().get(company?.id) }}
          </span>
        </div>
      </ng-template>
    </p-select>
    @let navItems = navigationItems();
    @if (navItems.length > 1) {
      <div role="navigation">
        <p-selectbutton
          [options]="navigationItems()"
          [ngModel]="currentSection"
          (ngModelChange)="goToPage($event)"
          unselectable
          aria-labelledby="basic"
        />
      </div>
    }
  </div>

  <div class="flex items-center gap-1">
    @if (canManageSettings()) {
      <p-button
        (onClick)="goToSettings()"
        icon="pi pi-cog"
        severity="secondary"
        ariaLabel="Impostazioni"
        pTooltip="Impostazioni"
        tooltipPosition="bottom"
        i18n-ariaLabel
        i18n-pTooltip
      />
    }
    <button
      (click)="menu.toggle($event)"
      aria-label="Menu utente"
      i18n-aria-label
    >
      <app-avatar
        [image]="avatarImage()"
        [initials]="initials()"
        [name]="name()"
      />
    </button>
  </div>
</header>

<app-menu #menu>
  @if (name() || email()) {
    <app-menu-content>
      @let name = this.name();
      @let email = this.email();
      <div class="flex items-center gap-2">
        <app-avatar
          [image]="avatarImage()"
          [initials]="initials()"
          [name]="name"
        />
        <div class="flex flex-col">
          <div class="font-medium leading-5">
            @if (name) {
              {{ name }}
            } @else {
              <ng-container i18n>Nessun nome</ng-container>
            }
          </div>
          <span class="text-muted text-xs">
            @if (email) {
              {{ email }}
            } @else {
              <ng-container i18n>Nessuna email</ng-container>
            }
          </span>
        </div>
      </div>
    </app-menu-content>
  }
  <app-menu-item
    (action)="goToAccount()"
    label="Account"
    i18n-label
    icon="pi pi-user"
  />
  @if (isSalesRep()) {
    <app-menu-item
      (action)="openAgentApp()"
      label="App agenti"
      i18n-label
      icon="pi pi-external-link"
    />
  }
  <app-menu-item
    (action)="logOut()"
    label="Esci"
    i18n-label
    icon="pi pi-sign-out"
  />
</app-menu>
